// @flow

import { COUNTRIES } from '@nv/rc/Constants'

export const POPULAR_STATES = {
  [COUNTRIES.VN]: ['Hà Nội', 'Hồ Chí Minh', 'Đà Nẵng', 'Cần Thơ']
}

export const COUNTRIES_WITH_EDIT_ORDER_ENABLED = [COUNTRIES.ID, COUNTRIES.PH, COUNTRIES.MY]
